import { createSlice, createAsyncThunk, AsyncThunk } from "@reduxjs/toolkit";
import { filterTableDataAPI } from "services/CRUDServices";
import { filterUrls } from "services/api.enums";

export const filterBarcodeMatching: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  "barcodematching",
  async (body: any) => {

    const data = await filterTableDataAPI(
      filterUrls.postLabelStick,
      body.pageNumber,
      { ...body, pageNumber: undefined, pageSize: undefined },
      true,
      10,
      false
    );

    return data.data;
  }
);

const initialState: any = {
  barcodeMatching: [],
  fetchpost: false,
  errorMessage: null,
  isUpdating: false,
  filter: {},
};

const BarcodeMatchingSlice = createSlice({
  initialState: initialState,
  name: "barcodematching",
  reducers: {
    clearBarcodeMatching: (state) => {
      state.barcodeMatching = [];
    },
    setFilterBarcodeMatching: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: {
    [filterBarcodeMatching.fulfilled as any]: (state, action) => {
      state.barcodeMatching = action.payload;
      state.fetchPost = false;
    },
    [filterBarcodeMatching.pending as any]: (state) => {
      state.fetchPost = true;
    },
    [filterBarcodeMatching.rejected as any]: (state) => {
      state.fetchPost = false;
      state.errorMessage = "wrong";
    },
  },
});

export const { setFilterBarcodeMatching, clearBarcodeMatching } = BarcodeMatchingSlice.actions;
export default BarcodeMatchingSlice.reducer;
